import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import { changeData, uploadFile } from "../../helpers/dbOperations";
import axios from "axios";

const MyAccount = ({ location, userData, saveUser }) => {
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni;
  const { pathname } = location;
  const { addToast } = useToasts();
  const [accountImage, setAccountImage] = useState("");
  //webAppPegasoChangeUserData

  function caricaCredenzialiCambioDati() {
    var Elemento;

    var Fields = [
      "CodFis",
      "ParIva",
      "CodDes",
      "EMailPec",
      "Ind",
      "Loc",
      "Cap",
      "Pro",
      "Nom",
      "Cog",
      "EMail",
      "SitWeb",
      "Tel",
      "Cel",
    ];
    var valueFields = {};

    Fields.map((field) => {
      Elemento = document.querySelector('[nomeField="' + field + '"]');
      valueFields[field] = Elemento ? Elemento.value : "";
      userData.user.user[field] = Elemento ? Elemento.value : "";
    });

    valueFields.username = userData.user.user.username;
    valueFields.password = userData.user.user.password;
    valueFields.passwordnew = userData.user.user.password;
    valueFields.TipoCambio = 1;

    saveUser(userData.user, null);

    return valueFields;
  }

  function caricaCredenzialiCambioPassword() {
    var Elemento;

    var Fields = [
      "CodFis",
      "ParIva",
      "CodDes",
      "EMailPec",
      "Ind",
      "Loc",
      "Cap",
      "Pro",
      "Nom",
      "Cog",
      "EMail",
      "SitWeb",
      "Tel",
      "Cel",
      "newPassword",
      "currentPassword",
    ];
    var valueFields = {};

    Fields.map((field) => {
      Elemento = document.querySelector('[nomeField="' + field + '"]');
      valueFields[field] = Elemento ? Elemento.value : "";
      userData.user.user[field] = Elemento ? Elemento.value : "";
    });

    valueFields.username = userData.user.user.username;
    valueFields.password = valueFields.currentPassword;
    valueFields.passwordnew = valueFields.newPassword;
    valueFields.TipoCambio = 2;

    saveUser(userData.user, null);

    return valueFields;
  }

  /*
  function onDrop(pictureFiles, pictureDataURLs) {
    this.setState({
      pictures: this.state.pictures.concat(pictureFiles)
    });
  }*/

  function cambiaDati() {
    var credentials = caricaCredenzialiCambioDati();
    //console.log("Parto con il Cambiamento dei dati con queste credenziali");
    changeData(credentials, addToast);
  }

  function cambiaPassword() {
    var credentials = caricaCredenzialiCambioPassword();
    changeData(credentials, addToast);
  }

  const uploadNew = async (file) => {
    var endPoint =
      "https://pegaso3cloudapi.pegasogest.it/api/pegasoCloud/api/upload";

    const risultato = await axios
      .post(endPoint, { file })
      .then((response) => response.data)
      .catch((error) => error);
    //console.log(risultato);
    const ritorno =
      risultato && risultato?.esito == "OK" ? risultato.linkFile : file;

    saveUser(
      { ...userData.user, user: { ...userData.user.user, WebImage: ritorno } },
      null
    );
    return ritorno;
  };

  const photoOnClick = () => {
    document.getElementById("profile-image-upload").click();
  };
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });
  const submitImage = (e) => {
    //console.log(e.target.files)
    document.getElementById("accountPic").src = URL.createObjectURL(
      e.target.files[0]
    );
    var nameFile = e.target.files[0].name;
    const imageStr = fileToBase64(e.target.files[0]).then((data) => {
      userData.user.user["WebImage"] = data;
      const body = {};
      body["idDetCliRef"] = userData.user.user.IdDetCliRef;
      body["photo"] = data.split(",")[1];
      var nameFileNew = Date.now() + "." + nameFile.split(".")[1];
      body["name"] = nameFileNew;
      //console.log(body)
      var endpoint = global.endpoint;
      uploadFile(body, addToast);
      saveUser(userData.user, null);
    });
  };
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.my_account} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.my_account + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne>
        {/* breadcrumb */}
        <Breadcrumb />
        <div className="myaccount-area pb-80 pt-100">
          <div className="container">
            <div className="row">
              <div className="ml-auto mr-auto col-lg-9">
                <div className="myaccount-wrapper">
                  <Accordion defaultActiveKey="0">
                    <Card className="single-my-account mb-20">
                      <Card.Header className="panel-heading">
                        <Accordion.Toggle variant="link" eventKey="0">
                          <h3 className="panel-title">
                            <span>1 .</span> Inserisci le Tue Informazioni{" "}
                          </h3>
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          <div className="myaccount-info-wrapper">
                            <div className="row">
                              <div className="col-lg-12 col-md-12">
                                <div className="billing-info">
                                  {/*}
                                <ImageUploader 
                                    withIcon={false}
                                    withPreview={false}
                                    label="Clicca per Cambiare la tua Immagine"
                                    buttonText="Cambia Foto"
                                    imgExtension={[".jpg", ".gif", ".png", ".gif", ".svg"]}
                                    maxFileSize={1048576}
                                    fileSizeError=" File Troppo Grande"
                                    onChange={onDrop}
                                    >
                                </ImageUploader>*/}
                                  <style>
                                    {`#accountPic:hover{outline:2px solid rgb(46, 152, 240)}`}
                                  </style>
                                  <input
                                    type="file"
                                    className="hidden"
                                    id="profile-image-upload"
                                    name="img"
                                    accept="image/*"
                                    onChange={(e) => submitImage(e)}
                                  ></input>
                                  <img
                                    id="accountPic"
                                    style={{
                                      height: 150,
                                      width: 150,
                                      padding: 10,
                                      margin: 10,
                                      cursor: "pointer",
                                    }}
                                    src={
                                      userData.user.user.WebImage
                                        ? userData.user.user.WebImage
                                        : "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"
                                    }
                                    onClick={() => photoOnClick()}
                                    title="Clicca per cambiare l'immagine"
                                  ></img>
                                  <label
                                    style={{
                                      color: "#2e98f0",
                                      fontSize: "22px",
                                    }}
                                  >
                                    Ragione Sociale: {userData.user.user.RagSoc}
                                  </label>
                                </div>
                              </div>
                            </div>
                            {/*<div className="account-info-wrapper">
                              <h4>DATI DI FATTURAZIONE</h4>
                              <h5>Informazioni Aziendali</h5>
  </div>*/}
                            <h5 style={{ color: "#2e98f0" }}>
                              DATI DI FATTURAZIONE - Informazioni Aziendali
                            </h5>

                            <div className="row">
                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Codice Fiscale</label>
                                  <input
                                    nome="CodFis"
                                    nomeField="CodFis"
                                    defaultValue={userData.user.user.CodFis}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Partita IVA</label>
                                  <input
                                    nome="ParIVA"
                                    nomeField="ParIva"
                                    defaultValue={userData.user.user.ParIva}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Cod.Destinatario</label>
                                  <input
                                    nome="CodDest"
                                    nomeField="CodDes"
                                    defaultValue={userData.user.user.CodDes}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>PEC</label>
                                  <input
                                    nome="EMailPec"
                                    nomeField="EMailPec"
                                    defaultValue={userData.user.user.EMailPec}
                                    disabled
                                    type="email"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-12 col-md-12">
                                <div className="billing-info">
                                  <label>Indirizzo</label>
                                  <input
                                    nome="Indirizzo"
                                    nomeField="Ind"
                                    defaultValue={userData.user.user.Ind}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Località</label>
                                  <input
                                    nome="SedLegLocalita"
                                    nomeField="Loc"
                                    defaultValue={userData.user.user.Loc}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-3">
                                <div className="billing-info">
                                  <label>CAP</label>
                                  <input
                                    nome="Cap"
                                    nomeField="Cap"
                                    defaultValue={userData.user.user.Cap}
                                    disabled
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-3">
                                <div className="billing-info">
                                  <label>Provincia</label>
                                  <input
                                    nome="SedLegPro"
                                    nomeField="Pro"
                                    defaultValue={userData.user.user.Pro}
                                    disabled
                                    type="text"
                                    maxLength="3"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-12 col-md-6 row">
                                <div className="account-info-wrapper">
                                  <h5 style={{ color: "#2e98f0" }}>
                                    LE MIE INFORMAZIONI - Informazioni Personali
                                  </h5>
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Nome</label>
                                  <input
                                    nome="Nom"
                                    nomeField="Nom"
                                    defaultValue={userData.user.user.Nom}
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Cognome</label>
                                  <input
                                    nome="Cog"
                                    nomeField="Cog"
                                    defaultValue={userData.user.user.Cog}
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Email</label>
                                  <input
                                    nome="Mail"
                                    nomeField="EMail"
                                    defaultValue={userData.user.user.EMail}
                                    disabled={global.aziendaID == 4}
                                    style={{
                                      color:
                                        global.aziendaID == 4
                                          ? "gray"
                                          : "black",
                                    }}
                                    type="email"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                {global.aziendaID != 4 && (
                                  <div className="billing-info">
                                    <label>Sito WEB</label>
                                    <input
                                      nome="Web"
                                      nomeField="SitWeb"
                                      defaultValue={userData.user.user.SitWeb}
                                      type="url"
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Numero Telefonico</label>
                                  <input
                                    nome="Tel"
                                    nomeField="Tel"
                                    defaultValue={userData.user.user.Tel}
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="billing-info">
                                  <label>Cellulare</label>
                                  <input
                                    nome="Cel"
                                    nomeField="Cel"
                                    defaultValue={userData.user.user.Cel}
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="billing-back-btn">
                              <div className="billing-btn">
                                <button onClick={cambiaDati} type="submit">
                                  Modifica Dati
                                </button>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="single-my-account mb-20">
                      <Card.Header className="panel-heading">
                        <Accordion.Toggle variant="link" eventKey="1">
                          <h3 className="panel-title">
                            <span>2 .</span> Cambia Password
                          </h3>
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          <div className="myaccount-info-wrapper">
                            <div className="account-info-wrapper">
                              <h4>Cambia Password</h4>
                            </div>
                            <div className="row">
                              <div className="col-lg-12 col-md-12">
                                <div className="billing-info">
                                  <label>Password attuale</label>

                                  <input
                                    nome="currentPassword"
                                    nomeField="currentPassword"
                                    defaultValue=""
                                    type="password"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-12 col-md-12">
                                <div className="billing-info">
                                  <label>Nuova password</label>

                                  <input
                                    nome="newPassword"
                                    nomeField="newPassword"
                                    defaultValue=""
                                    type="password"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="billing-back-btn">
                              <div className="billing-btn">
                                <button onClick={cambiaPassword} type="submit">
                                  Modifica Password
                                </button>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    {false && (
                      <Card className="single-my-account mb-20">
                        <Card.Header className="panel-heading">
                          <Accordion.Toggle variant="link" eventKey="2">
                            <h3 className="panel-title">
                              <span>3 .</span> Modifica i Tuoi Dati{" "}
                            </h3>
                          </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="2">
                          <Card.Body>
                            <div className="myaccount-info-wrapper">
                              <div className="account-info-wrapper">
                                <h4>Address Book Entries</h4>
                              </div>
                              <div className="entries-wrapper">
                                <div className="row">
                                  <div className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center">
                                    <div className="entries-info text-center">
                                      <p>Farhana hayder (shuvo) </p>
                                      <p>hastech </p>
                                      <p> Road#1 , Block#c </p>
                                      <p> Rampura. </p>
                                      <p>Dhaka </p>
                                      <p>Bangladesh </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center">
                                    <div className="entries-edit-delete text-center">
                                      <button className="edit">Edit</button>
                                      <button>Delete</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="billing-back-btn">
                                <div className="billing-btn">
                                  <button type="submit">Continua</button>
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    )}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

MyAccount.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
